var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.14 30.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c7a00d;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 26.07,
    width: 95.09,
    height: 4.2,
    transform: "translate(.05 -.08) rotate(.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.02,
    y: 0.08,
    width: 95.09,
    height: 26.07,
    transform: "translate(.02 -.08) rotate(.1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutres);
export default __webpack_public_path__ + "static/media/autres.8387df72fe35c1031b457a5ffb6c0c32.svg";
export { ForwardRef as ReactComponent };